<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-row class="hidden-xs-only">
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                @click="(showNeueVeranstaltung = true) && (neueVeranstaltung = { kalender: kalender[0] })"
                v-on="on"
                ><v-icon>add</v-icon></v-btn
              >
            </template>
            <span>Erstellen</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4" class="text-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="$refs.calendar.prev()" v-on="on"><v-icon>keyboard_arrow_left</v-icon></v-btn>
            </template>
            <span>Letzter Monat</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn text @click="setToday()" v-on="on">{{ $filters.date(start, "MM.YYYY") }}</v-btn>
            </template>
            <span>Aktueller Monat</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="$refs.calendar.next()" v-on="on"><v-icon>keyboard_arrow_right</v-icon></v-btn>
            </template>
            <span>Nächster Monat</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider></v-divider>

    <v-dialog
      v-model="showNeueVeranstaltung"
      width="50%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
    >
      <v-card rounded="xl">
        <v-card-title>
          <div>Neue Veranstaltung erstellen</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="showNeueVeranstaltung = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text class="px-0">
          <v-row no-gutters>
            <v-col cols="12" md="12" class="px-1">
              <v-card outlined height="100%">
                <v-row class="ma-2" no-gutters>
                  <v-col cols="12" class="pa-1">
                    <v-text-field
                      dense
                      hide-details
                      outlined
                      label="Titel"
                      v-model="neueVeranstaltung.titel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" md="3" class="pa-1">
                    <v-menu
                      ref="neueVeranstaltung.vonDatum"
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="formatVonDatum"
                          label="Beginn"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        reactive
                        @change="changeVonDatum"
                        prev-icon="keyboard_arrow_left"
                        next-icon="keyboard_arrow_right"
                        v-model="neueVeranstaltung.vonDatum"
                        locale="de-de"
                        first-day-of-week="1"
                        @input="menu1 = false"
                        no-title
                        scrollable
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" md="3" class="pa-1">
                    <v-menu
                      ref="neueVeranstaltung.vonZeit"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="neueVeranstaltung.vonZeit"
                          label="Um"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        :allowed-minutes="allowedMinutes"
                        format="24hr"
                        prev-icon="keyboard_arrow_left"
                        next-icon="keyboard_arrow_right"
                        v-model="neueVeranstaltung.vonZeit"
                        locale="de-de"
                        first-day-of-week="1"
                        scrollable
                      >
                      </v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" md="3" class="pa-1">
                    <v-menu
                      ref="neueVeranstaltung.bisDatum"
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="formatBisDatum"
                          label="Ende"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        prev-icon="keyboard_arrow_left"
                        next-icon="keyboard_arrow_right"
                        v-model="neueVeranstaltung.bisDatum"
                        locale="de-de"
                        first-day-of-week="1"
                        @input="menu3 = false"
                        no-title
                        scrollable
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" md="3" class="pa-1">
                    <v-menu
                      ref="neueVeranstaltung.bisZeit"
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="neueVeranstaltung.bisZeit"
                          label="Um"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        :allowed-minutes="allowedMinutes"
                        format="24hr"
                        prev-icon="keyboard_arrow_left"
                        next-icon="keyboard_arrow_right"
                        v-model="neueVeranstaltung.bisZeit"
                        locale="de-de"
                        first-day-of-week="1"
                        scrollable
                      >
                      </v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" class="pa-1">
                    <v-autocomplete
                      dense
                      hide-details
                      outlined
                      :items="kleiderordnungen"
                      label="Kleiderordnung"
                      v-model="neueVeranstaltung.kleiderordnung"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pa-1">
                    <v-text-field
                      dense
                      hide-details
                      outlined
                      label="Ort"
                      v-model="neueVeranstaltung.ort"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-1">
                    <v-text-field
                      dense
                      hide-details
                      outlined
                      messages="o/ho"
                      label="Kategorie"
                      v-model="neueVeranstaltung.kategorie"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-1">
                    <v-text-field
                      dense
                      hide-details
                      outlined
                      label="Preis"
                      v-model="neueVeranstaltung.preis"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-1">
                    <v-menu
                      ref="neueVeranstaltung.anmeldungBis"
                      v-model="menu5"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="neueVeranstaltung.anmeldungBis"
                          label="Anmeldung bis"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        prev-icon="keyboard_arrow_left"
                        next-icon="keyboard_arrow_right"
                        v-model="neueVeranstaltung.anmeldungBis"
                        locale="de-de"
                        first-day-of-week="1"
                        @input="menu5 = false"
                        no-title
                        scrollable
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="3" class="pa-1">
                    <v-select
                      dense
                      hide-details
                      outlined
                      :items="itemsKalender"
                      label="Kalender"
                      v-model="neueVeranstaltung.kalender"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" class="pa-1">
                    <v-autocomplete
                      dense
                      hide-details
                      hint="Pflichtanmeldungen können nicht mehr bearbeitet werden!"
                      multiple
                      outlined
                      dele
                      deletable-chips
                      chips
                      clearable
                      clear-icon="close"
                      :items="gruppen"
                      label="Pflichtanmeldungen"
                      v-model="neueVeranstaltung.pflichtanmeldungen"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" class="pa-1">
                    <v-textarea
                      dense
                      hide-details
                      outlined
                      auto-grow
                      rows="5"
                      label="Bemerkung"
                      v-model="neueVeranstaltung.bemerkung"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showNeueVeranstaltung = false">Abbrechen</v-btn>
          <v-btn
            class="primary"
            text
            :disabled="
              !(
                neueVeranstaltung.kalender &&
                !(neueVeranstaltung.titel == null || neueVeranstaltung.titel.trim() === '') &&
                !(formatVonDatum == null || formatVonDatum.trim() === '')
              )
            "
            @click="saveVeranstaltung()"
            >Speichern</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row class="ma-0">
      <v-col cols="12">
        <v-card flat class="rounded-0" :height="'calc(100vh - 195px)'">
          <v-calendar
            v-touch="{ right: () => $refs.calendar.prev(), left: () => $refs.calendar.next() }"
            ref="calendar"
            v-model="start"
            color="primary"
            :events="events"
            :short-weekdays="shortWeekdays"
            :short-months="shortMonths"
            :now="now"
            :event-more="false"
            type="month"
            locale="de-de"
            :weekdays="weekdays"
            :event-color="getEventColor"
            event-text-color="white"
            @click:event="showEvent"
          ></v-calendar>
          <dialogVeranstaltung
            :visible.sync="selectedOpen"
            :selectedEvent="selectedEvent"
            @close="selectedOpen = false"
          ></dialogVeranstaltung>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: ["kalender"],
    data() {
      return {
        search: "",
        showVeranstaltungEdit: false,
        showNeueVeranstaltung: false,
        start: new Date().toISOString().substr(0, 10),
        now: new Date().toISOString().substr(0, 10),
        shortWeekdays: true,
        shortMonths: true,
        weekdays: [1, 2, 3, 4, 5, 6, 0],
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        neueVeranstaltung: {
          kalender: this.kalender[0],
        },
        kleiderordnungen: [
          "Gepflegt leger",
          "Gepflegt leger mit Hemd",
          "Kombination",
          "Kombination mit plenis coloribus",
          "Dunkler Anzug",
          "Dunkler Anzug mit plenis coloribus",
          "Abendgarderobe",
        ],
        gruppen: [
          { text: "Füxe", value: "Fux" },
          { text: "Aktive", value: "Aktiver" },
          { text: "Inaktive in loco", value: "Inaktiver in loco" },
          { text: "Inaktive extra locum", value: "Inaktiver extra locum" },
        ],
        istNeu: false,
        date: "",
        menu1: "",
        menu2: "",
        menu3: "",
        menu4: "",
        menu5: "",
        neueAnmeldung: "",
        neueAnmeldungWeitere: {},
        showDeleteVeranstaltung: false,
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      itemsKalender() {
        let kalender = [];
        Object.keys(this.$store.getters["einstellungen/einstellung"]("alleKalender")).forEach((key) => {
          if (key !== "id") {
            kalender.push({
              value: this.$store.getters["einstellungen/einstellung"]("alleKalender")[key].name,
              text: this.$store.getters["einstellungen/einstellung"]("alleKalender")[key].name,
            });
          }
        });
        return kalender;
      },
      formatVonDatum() {
        if (!this.neueVeranstaltung.vonDatum) return null;
        return new Date(this.neueVeranstaltung.vonDatum).toLocaleString(["de-de"], {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "2-digit",
        });
      },
      formatBisDatum() {
        if (!this.neueVeranstaltung.bisDatum) return null;
        return new Date(this.neueVeranstaltung.bisDatum).toLocaleString(["de-de"], {
          month: "short",
          weekday: "short",
          day: "numeric",
          year: "2-digit",
        });
      },
      // convert the list of events into a map of lists keyed by date
      eventsMap() {
        const map = {};
        this.events.forEach((e) => (map[e.date] = map[e.date] || []).push(e));
        return map;
      },
      events() {
        let events = this.$store.state.veranstaltungen.veranstaltungen;
        events.forEach((event) => {
          event.start = event.vonDatum + " " + event.vonZeit;
          event.end = event.bisDatum;
          event.name = event.titel;
        });
        return events;
      },
    },
    methods: {
      changeVonDatum() {
        if (!this.neueVeranstaltung.bisDatum) {
          this.neueVeranstaltung.bisDatum = this.neueVeranstaltung.vonDatum;
        }
        if (!this.neueVeranstaltung.bisZeit) {
          this.neueVeranstaltung.bisZeit = "23:55";
        }
        if (!this.neueVeranstaltung.vonZeit) {
          this.neueVeranstaltung.vonZeit = "20:15";
        }
      },
      getEventColor(event) {
        let kalender = this.$store.getters["einstellungen/einstellung"]("alleKalender").find(
          (item) => item.name === event.kalender
        );
        let farbe;
        if (kalender) {
          farbe = kalender.farbe.hex;
        } else {
          farbe = "#ff";
        }
        return farbe;
      },
      allowedMinutes: (m) => m % 5 === 0,
      saveVeranstaltung() {
        this.neueVeranstaltung.anmeldungen = [];
        this.neueVeranstaltung.weitereAnmeldungen = [];
        if (this.neueVeranstaltung.pflichtanmeldungen) {
          this.neueVeranstaltung.pflichtanmeldungen.forEach((status) => {
            this.$store.getters["bbrbbr/bbrStatus"](status).forEach((bbr) => {
              if (this.neueVeranstaltung.anmeldungen.indexOf(bbr.id) === -1) {
                this.neueVeranstaltung.anmeldungen.push(bbr.id);
              }
            });
          });
        } else {
          this.neueVeranstaltung.pflichtanmeldungen = [];
        }
        this.$store.dispatch("veranstaltungen/createVeranstaltung", this.neueVeranstaltung);
        this.neueVeranstaltung = {};
        this.showNeueVeranstaltung = false;
      },
      showEvent({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event;
          this.selectedElement = nativeEvent.target;
          setTimeout((this.selectedOpen = true), 10);
        };

        if (this.selectedOpen) {
          this.selectedOpen = false;
          setTimeout(open, 10);
        } else {
          open();
        }

        nativeEvent.stopPropagation();
      },
      anmeldungEntfernen(item) {
        this.neueVeranstaltung.anmeldungen.splice(this.neueVeranstaltung.anmeldungen.indexOf(item), 1);
      },
      anmeldungHinzufuegen() {
        if (this.neueVeranstaltung.anmeldungen.indexOf(this.neueAnmeldung) === -1) {
          this.neueVeranstaltung.anmeldungen.push(this.neueAnmeldung);
        }
        this.neueAnmeldung = "";
      },
      anmeldungEntfernenWeitere(item) {
        this.neueVeranstaltung.weitereAnmeldungen.splice(this.neueVeranstaltung.weitereAnmeldungen.indexOf(item), 1);
      },
      anmeldungHinzufuegenWeitere() {
        this.neueVeranstaltung.weitereAnmeldungen.push({
          angemeldetVon: this.neueAnmeldungWeitere.angemeldetVon,
          name: this.neueAnmeldungWeitere.name,
        });
        this.neueAnmeldungWeitere = {};
      },
      addEvent({ date }) {
        // console.log('Add Event')
        // this.focus = date
        // this.type = 'day'
      },
      showDay({ date }) {
        // console.log('Show Day')
        // this.focus = date
        // this.type = 'day'
      },
      setToday() {
        this.start = new Date().toISOString().substr(0, 10);
      },
      open(event) {
        alert(event.title);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }

  .v-calendar-weekly {
    display: grid;
    table-layout: fixed;
  }
    .v-calendar-weekly__week {
    height: auto;
    display: table-row;
    }
    .v-calendar-weekly__day {
    display: table-cell;
    width: calc(100% / 7)
    }
</style>



// WEBPACK FOOTER //
// veranstaltungen.vue?145052f4